export default __webpack_public_path__ + "static/media/Spellbane Mantle.2669b2bb.jpg";